import React from "react";
import BotaoExcluir from "../../common/button/botaoExcluir";
export function TooltipAgendamento({ item, usuarioLogado, handleExcluirAgendamento }) {
    if (!item.agendamentos.length) return null;

    return (
        <div
            style={{
                backgroundColor: "#f1cf1a",
                color: "#111",
                padding: 4,
                borderRadius: "0.3rem",
                fontSize: "0.8rem",
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                width: 200,
                margin: 3,
            }}
        >
            <div
                style={{
                    margin: 0,
                    textAlign: "center",
                    minWidth: "100%",
                }}
            >
                <u>
                    <b>Agendamento de Alteração de Demanda:</b>
                </u>
            </div>
            {item.agendamentos.map((agendamentoDemanda) => {
                const dataAtual = new Date();
                const mesAtual = (dataAtual.getMonth() + 1 < 10 ? "0" : "") + (dataAtual.getMonth() + 1);
                const anoAtual = String(dataAtual.getFullYear());
                const mesAgendamento = String(agendamentoDemanda.competencia_inicio_vigencia).substring(4, 6);
                const anoAgendamento = String(agendamentoDemanda.competencia_inicio_vigencia).substring(0, 4);

                const competenciaAgendamentoVencida = agendamentoDemanda.competencia_inicio_vigencia < parseInt(anoAtual + mesAtual);
                const estiloAgendamentoVencido = competenciaAgendamentoVencida
                    ? {
                          border: "1px solid #000000",
                          padding: "0 2px",
                          borderRadius: "0.3rem",
                          color: "#ff0000",
                          fontWeight: 450,
                      }
                    : {};
                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/demandaContrato.js (excluirAgendamento) e no endpoint DELETE /api/demandaAgendamento
                const exibitBotaoExcluirAgendamento = usuarioLogado.acesso_cadastro_demanda_editar && competenciaAgendamentoVencida;
                return (
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: "100%",
                        }}
                    >
                        <span style={estiloAgendamentoVencido}>{agendamentoDemanda.mensagem_tooltip}</span>
                        {exibitBotaoExcluirAgendamento ? <BotaoExcluir event={() => handleExcluirAgendamento({ agendamentoDemanda, mesAgendamento, anoAgendamento })} /> : null}
                    </div>
                );
            })}
        </div>
    );
}
